import exerciseCardWhiteStyles from './exercise-card-white.module.less'
import exerciseCardDarkStyles from './exercise-card-dark.module.less'
import styles from './card-style.module.less'
import {
  Image,
  message,
  Button,
  Col,
  ConfigProvider,
  Row,
  Space,
  Popconfirm,
} from 'antd'

import React, { useEffect, useState } from 'react'

import {
  UpOutlined,
  DownOutlined,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons'

import rehypeHighlight from 'rehype-highlight'

import zhCN from 'antd/lib/locale/zh_CN'
import Cookies from 'js-cookie'
import { Checkbox } from 'antd'
import { Radio } from 'antd'

import * as constants from '../../constants/constants'

import remarkMath from 'remark-math'
import gfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you

import { sendHttpPostRequest } from '../../api/http-request'
//import {checkIsTeacher} from "../../component/modal/teacher-authenticate/teacher-authenticate";

/* 单选题 */

export interface Props {
  exercise: any
  renderType: string //渲染的主题类型，"dark","white"
  projectId: number
  resultPreview?: boolean
  isSubmit?: boolean
}

export const ExerciseCardSingleSelect: React.FC<Props> = (props) => {
  const { exercise, renderType, projectId, resultPreview, isSubmit } = props

  const options =
    typeof exercise.options === 'string'
      ? JSON.parse(exercise.options)
      : exercise.options
  const [answerList, setAnswerList] = useState([
    exercise?.submit_info?.answer[0] ?? [],
  ]) // 选择的答案
  const [running, setRunning] = useState(false) // 运行中状态

  const [answervisible, setAnswerVisible] = useState(false)

  const [currentStatus, setCurrentStatus] = useState(null as any)

  const exerciseCardStyles =
    renderType == 'white' ? exerciseCardWhiteStyles : exerciseCardDarkStyles

  useEffect(() => {
    setAnswerList(
      exercise?.submit_info?.answer[0] ? [exercise?.submit_info?.answer[0]] : []
    )
  }, [exercise])

  // 习题运行回调
  const runCodeCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
      // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
    } else if (response.code == 0) {
      // 成功
      // TODO: 答题卡片渲染执行结果，不在这里弹提示
      if (response.data.status == true) {
        //message.success(`回答正确`);
        setCurrentStatus(true)
      } else {
        //message.error(`回答错误`);
        setCurrentStatus(false)
      }
    } else if (response.code == -501) {
      // 权限不足
      // document.getElementById("show-login-modal")!.click();
      // window.location.href = `/oam_login?next=oam_preview_exercise?exercise_id=${exercise.id}`;
    } else {
      message.error(response.message)
    }
    setRunning(false)
  }

  //点击了提交按钮
  const exerciseSubmitBtnClick = () => {
    let data = {
      exercise_id: exercise.id,
      project_id: projectId,
      answer: JSON.stringify(answerList),
    }
    // setRunning(true)
    // sendHttpPostRequest(
    //   'exercise/api/exercise_run/',
    //   {
    //     sessionid: Cookies.get('sessionid'),
    //     exercise_id: exercise.id,
    //     project_id: projectId,
    //     answer_list: JSON.stringify(answerList),
    //   },
    //   runCodeCallback
    // )
    sendHttpPostRequest(
      'exercise/api/submit_test_exercise_by_id',
      data,
      runCodeCallback
    )
    /*if (!checkIsTeacher()) {
            document.getElementById("show-teacher-authenticate")!.click();
        } else {
            setRunning(true);
            sendHttpPostRequest(
                'exercise/api/exercise_run/',
                {
                    sessionid: Cookies.get("sessionid"),
                    exercise_id: exercise.id,
                    answer_list: JSON.stringify(answerList)
                },
                runCodeCallback
            )
        }*/
  }

  // 点了单选按钮
  const onOptionsChange = (event: any) => {
    setCurrentStatus(null as any)
    setAnswerList([parseInt(event.target.value)])
    exercise.submit_info.answer = [parseInt(event.target.value)]
  }

  // 看答案回调
  const queryExerciseAnswerCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      document.getElementById('show-login-modal')!.click()
    } else if (response.code == 0) {
      // 成功
      if (response.exercise_answer) {
        exercise.options_answer = response.exercise_answer.options_answer
        exercise.answer_parse = response.exercise_answer.answer_parse
        setAnswerVisible(true)
      }
    } else if (response.code == -501) {
      // 权限不足
      // document.getElementById("show-login-modal")!.click();
    } else {
      message.error(response.message)
    }
  }

  //点击了参考答案按钮
  const exerciseAnswerBtnClick = () => {
    if (exercise.options_answer && exercise.options_answer.length == 0) {
      // 查询答案
      sendHttpPostRequest(
        'exercise/api/query_exercise_answer/',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          exercise_id: exercise.id,
        },
        queryExerciseAnswerCallback
      )
    } else {
      setAnswerVisible(!answervisible)
    }
  }

  // 渲染 查看答案按钮
  const renderAnswerButton = () => {
    if (exercise.options_answer && 0 == exercise.options_answer.length) {
      return (
        <Popconfirm
          placement="bottom"
          title={'您确定查看答案吗？'}
          onCancel={(e: any) => {
            e.stopPropagation()
          }}
          onConfirm={(e: any) => {
            e.stopPropagation()
            exerciseAnswerBtnClick()
          }}
          okText="确认"
          cancelText="取消"
        >
          <Button
            hidden={true}
            type="link"
            style={{ width: 80, marginRight: 10, borderRadius: 20 }}
          >
            {' '}
            <span>答案解析</span>
            <DownOutlined />{' '}
          </Button>
        </Popconfirm>
      )
    } else {
      return (
        <Button
          hidden={true}
          onClick={exerciseAnswerBtnClick}
          type="link"
          style={{ width: 80, marginRight: 10, borderRadius: 20 }}
        >
          <span>答案解析</span>
          {!answervisible ? <DownOutlined /> : <UpOutlined />}
        </Button>
      )
    }
  }

  const getRunnigStatusBtn = () => {
    if (currentStatus == true) {
      return (
        <Button
          hidden={true}
          onClick={exerciseSubmitBtnClick}
          id={'test-exercise-run-' + exercise.id}
          type="default"
          style={{
            paddingLeft: 5,
            borderRadius: 3,
            width: 80,
            color: '#22c55e',
            borderColor: '#22c55e',
          }}
        >
          {' '}
          <CheckOutlined />正 确
        </Button>
      )
    } else if (currentStatus == false) {
      return (
        <Button
          hidden={true}
          onClick={exerciseSubmitBtnClick}
          id={'test-exercise-run-' + exercise.id}
          danger
          type="default"
          style={{
            paddingLeft: 5,
            color: '#ff4b50',
            borderRadius: 3,
            width: 80,
          }}
        >
          {' '}
          <CloseOutlined />错 误
        </Button>
      )
    } else {
      return (
        <Button
          hidden={true}
          onClick={exerciseSubmitBtnClick}
          loading={running}
          id={'test-exercise-run-' + exercise.id}
          type="primary"
          style={{ borderRadius: 3, width: 80 }}
        >
          {' '}
          测 试{' '}
        </Button>
      )
    }
  }

  return (
    <div
      style={{ marginBottom: 20, textAlign: 'left' }}
      className={exerciseCardStyles.wrapper}
    >
      <div style={{ fontSize: 14 }}>
        <ReactMarkdown
          className={exerciseCardStyles.reactmarkdownTitle}
          remarkPlugins={[gfm, remarkMath]}
          rehypePlugins={[rehypeHighlight, rehypeKatex]}
        >
          {'【单选】' + exercise?.title}
        </ReactMarkdown>
        <div style={{ marginTop: 10, marginBottom: 10, position: 'relative' }}>
          {exercise?.images?.map((image: any) => {
            return (
              <div
                key={image.name}
                style={{
                  margin: '10px auto 0px auto',
                  width: '100%',
                  height: '100%',
                  maxWidth: 500,
                  textAlign: 'center',
                }}
              >
                <img
                  width={'100%'}
                  height={'100%'}
                  style={{ backgroundColor: '#f2f2f2', borderRadius: 3 }}
                  src={constants.BACKEND_URL + image.path + image.name}
                />
              </div>
            )
          })}
        </div>
      </div>
      <div  className={exerciseCardStyles.optionGroupWrapper} >
        <Radio.Group
          onChange={onOptionsChange}
          value={String(exercise?.submit_info?.answer[0])}
          disabled={isSubmit && resultPreview}
         
        >
          <Space size="small" direction="vertical">
            {options.map((option) => {
              return (
                <div
                  style={{ width: '100%' }}
                  className={exerciseCardStyles.option}
                  key={option.id}
                >
                  <Radio
                    id={`exercise-${exercise.id}-option-${option.id}`}
                    style={{
                      padding: 5,
                      //marginLeft: 20,
                      minHeight: 30,
                      display: 'flex',
                      alignItems: 'center',
                      alignContent: 'center',
                    }}
                    key={option.id}
                    value={option.id}
                    data-v={
                      exercise?.submit_info?.answer?.includes(
                        parseInt(option.id)
                      )
                        ? true
                        : false
                    }
                  >
                    <div>
                      <ReactMarkdown
                        className={
                          exerciseCardStyles.reactmarkdownOption +
                            ' ' +
                            isSubmit && resultPreview
                            ? exercise?.answer?.includes(option.id - 0)
                              ? styles.rigthOpt
                              : !exercise?.answer?.includes(option.id - 0) &&
                                exercise?.submit_info?.answer?.includes(
                                  option.id - 0
                                )
                              ? styles.errorOpt
                              : renderType == 'white'
                              ? styles.defaultWhite
                              : styles.default
                            : renderType == 'white'
                            ? styles.defaultWhite
                            : styles.default
                        }
                        remarkPlugins={[gfm, remarkMath]}
                        rehypePlugins={[rehypeKatex, rehypeRaw]}
                      >
                        {option.id + '. ' + option.options}
                      </ReactMarkdown>
                    </div>
                  </Radio>
                </div>
              )
            })}
          </Space>
        </Radio.Group>
      </div>

      {isSubmit && resultPreview && (
        <div className={styles.resultContain}>
          <div
            className={
              renderType == 'white' ? styles.whiteTitle : styles.resultTitle
            }
          >
            答案解析
          </div>
          <ReactMarkdown
            className={exerciseCardStyles.reactmarkdown}
            remarkPlugins={[gfm, remarkMath]}
            rehypePlugins={[rehypeKatex, rehypeRaw]}
          >
            {exercise.answer_parse}
          </ReactMarkdown>
          {/* <div className={styles.resultConstent}>{exercise.answer_parse}</div> */}
        </div>
      )}

      <Row
        justify="start"
        align="middle"
        gutter={[8, 8]}
        style={{ marginTop: 20 }}
      >
        <Col flex={'100px'} style={{ textAlign: 'left' }}>
          {getRunnigStatusBtn()}
        </Col>
        <Col flex={'auto'} style={{ textAlign: 'left' }}></Col>
        <Col flex={'100px'} style={{ textAlign: 'right' }}>
          {renderAnswerButton()}
        </Col>
      </Row>

      {answervisible && (
        <div
          style={{ marginTop: 20, padding: 10, borderRadius: 5 }}
          className={exerciseCardStyles.answerParse}
        >
          <ReactMarkdown
            className={exerciseCardStyles.reactmarkdown}
            remarkPlugins={[gfm, remarkMath]}
            rehypePlugins={[rehypeKatex, rehypeRaw]}
          >
            {exercise.answer_parse}
          </ReactMarkdown>
        </div>
      )}
    </div>
  )
}

export default ExerciseCardSingleSelect
